import { render, staticRenderFns } from "./RegulationsContent.vue?vue&type=template&id=41ce5f17&scoped=true&"
import script from "./RegulationsContent.vue?vue&type=script&lang=js&"
export * from "./RegulationsContent.vue?vue&type=script&lang=js&"
import style0 from "./RegulationsContent.vue?vue&type=style&index=0&id=41ce5f17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ce5f17",
  null
  
)

export default component.exports